import { render, staticRenderFns } from "./MgrLine.vue?vue&type=template&id=868c56b2&scoped=true"
import script from "./MgrLine.vue?vue&type=script&lang=js"
export * from "./MgrLine.vue?vue&type=script&lang=js"
import style0 from "./MgrLine.vue?vue&type=style&index=0&id=868c56b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868c56b2",
  null
  
)

export default component.exports